import {
  Actions as CreepActions,
  ADD_CREEP,
  REMOVE_CREEP,
  UPDATE_CREEP,
  RESTORE_CREEPS
} from './creeps.actions';

import { Creep } from '../creep';

export interface State {
  level: number;
  creeps: Creep[];
}

export const initialState: State = {
  level: 0,
  creeps: []
};

export function reducer(state: State = initialState, action: CreepActions): State {
  console.log('reducer', action);

  switch (action.type) {
    case ADD_CREEP: {
      const creep = action.payload;
      const level = state.level + creep.level + 1;

      return {
        level,
        creeps: [
          ...state.creeps,
          creep
        ]
      };
    }

    case REMOVE_CREEP: {
      const creep = action.payload;
      const idx = state.creeps.indexOf(creep);
      state.creeps.splice(idx, 1);

      const level = state.level - creep.level - 1;

      return {
        level,
        creeps: [
          ...state.creeps
        ]
      };
    }

    case UPDATE_CREEP: {
      const [newCreep, oldCreep] = action.payload;
      const idx = state.creeps.indexOf(oldCreep);
      state.creeps.splice(idx, 1, newCreep);

      const level = state.level - oldCreep.level + newCreep.level;

      return {
        level,
        creeps: [
          ...state.creeps
        ]
      };
    }

    case RESTORE_CREEPS: {
      const creeps = action.payload;
      const level = creeps.reduce((_: number, c: Creep) => _ + c.level, creeps.length);

      return {
        level,
        creeps: [
          ...action.payload
        ]
      };
    }

    default:
      return state;
  }
}

// Store selectors.
export const selectLevel = (state: State) => state.level;
export const selectCreeps = (state: State) => state.creeps;



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/store.module/creeps.reducer.ts